<app-crudbar-nav #crudbar (onReady)="doComReady($event,'crudbar-nav')" [editAndSaveVisible]="true">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup class="jk-tab-group" (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">

    <div class="w-full h-full ">
      <app-jkaggrid #myGrid [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)">
      </app-jkaggrid>
    </div>
  </mat-tab>
  <mat-tab #myTabDetail label="明細">
  </mat-tab>
  <mat-tab #myTabDetail label="筆記查詢">
    <mat-toolbar class="flex space-x-1">
      <button class="btn" [class.btn-primary]="true" (click)="doQueryStkwl()">筆記查詢</button>
    </mat-toolbar>
    <div >
        <app-jkrange #stkwl005 class="jk-range" [emojiLabel]="'😂'" [label]="'日期'" [required]="true" [(valueA)]="stkwl005_1"
          [showOpenWinButton]="false" [(valueB)]="stkwl005_2">
        </app-jkrange>
    </div>

    <app-jkgridwin [width]="screenWidth" [defaultHeight]="400" ariaLabel="技術分析明細" (afterQuery)="afterQueryStkwl($event)"
      (afterGridReady)="afterGridReadyStkwl($event)">
    </app-jkgridwin>
  </mat-tab>
</mat-tab-group>
